import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { DefaultHttpRequest19v463zllbymg as DefaultHttpRequest } from '../request/DefaultHttpRequest.mjs';
import { DefaultHttpResponse2wnrinzo0twhn as DefaultHttpResponse } from '../statement/DefaultHttpResponse.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { instanceOf2cx3k00nj6a0p as instanceOf } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/TypeInfo.web.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from '../plugins/SaveBody.mjs';
import { HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer } from '../statement/HttpResponsePipeline.mjs';
import { NullBody_instance3jaj4elqoxne0 as NullBody_instance } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  cancel2ztysw4v4hav6 as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../statement/HttpResponse.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'CustomResponse';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = PrimitiveClasses_getInstance().of();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(PrimitiveClasses_getInstance().of(), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.z5k_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpClientCallClass;
function HttpClientCall() {
  if (HttpClientCallClass === VOID) {
    class $ {
      static e5k(client) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.a5i_1 = client;
        $this.b5i_1 = atomic$boolean$1(false);
        $this.e5i_1 = false;
        return $this;
      }
      dw() {
        return this.f5i().dw();
      }
      g5k() {
        return this.f5k().g5k();
      }
      f5k() {
        var tmp = this.c5i_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('request');
        }
      }
      f5i() {
        var tmp = this.d5i_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('response');
        }
      }
      static a5l(client, requestData, responseData) {
        Companion_getInstance();
        var $this = this.e5k(client);
        $this.c5i_1 = new (DefaultHttpRequest())($this, requestData);
        $this.d5i_1 = new (DefaultHttpResponse())($this, responseData);
        $this.g5k().r4n(Companion_getInstance().z5k_1);
        var tmp = responseData.f5l_1;
        if (!isInterface(tmp, ByteReadChannel())) {
          $this.g5k().p4n(Companion_getInstance().z5k_1, responseData.f5l_1);
        }
        return $this;
      }
      h5k() {
        return this.e5i_1;
      }
      *i5k($completion) {
        return this.f5i().u5k();
      }
      *j5k(info, $completion) {
        try {
          if (instanceOf(this.f5i(), info.s4t_1))
            return this.f5i();
          if (!this.h5k() && !get_isSaved(this.f5i()) && !this.b5i_1.atomicfu$compareAndSet(false, true)) {
            throw DoubleReceiveException().n5l(this);
          }
          var tmp0_elvis_lhs = this.g5k().n4n(Companion_getInstance().z5k_1);
          var responseData = tmp0_elvis_lhs == null ? (yield* this.i5k($completion)) : tmp0_elvis_lhs;
          var subject = new (HttpResponseContainer())(info, responseData);
          // Inline function 'kotlin.takeIf' call
          var this_0 = (yield* this.a5i_1.t5h_1.z4s(this, subject, $completion)).p5l_1;
          var tmp;
          if (!equals(this_0, NullBody_instance)) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var result = tmp;
          if (!(result == null) && !instanceOf(result, info.s4t_1)) {
            var from = getKClassFromExpression(result);
            var to = info.s4t_1;
            throw NoTransformationFoundException().v5l(this.f5i(), from, to);
          }
          return result;
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            cancel(this.f5i(), 'Receive failed', cause);
            throw cause;
          } else {
            throw $p;
          }
        }
      }
      toString() {
        return 'HttpClientCall[' + this.f5k().o5k().toString() + ', ' + this.f5i().v5k().toString() + ']';
      }
      g5i(response) {
        this.d5i_1 = response;
      }
    }
    initMetadataForClass($, 'HttpClientCall', VOID, VOID, [CoroutineScope()], [0, 1]);
    HttpClientCallClass = $;
  }
  return HttpClientCallClass;
}
var DoubleReceiveExceptionClass;
function DoubleReceiveException() {
  if (DoubleReceiveExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static n5l(call) {
        var $this = this.m();
        captureStack($this, $this.m5l_1);
        $this.l5l_1 = 'Response already received: ' + call.toString();
        delete $this.message;
        return $this;
      }
      r() {
        return this.l5l_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'DoubleReceiveException');
    DoubleReceiveExceptionClass = $;
  }
  return DoubleReceiveExceptionClass;
}
var NoTransformationFoundExceptionClass;
function NoTransformationFoundException() {
  if (NoTransformationFoundExceptionClass === VOID) {
    class $ extends UnsupportedOperationException() {
      static v5l(response, from, to) {
        var $this = this.j8();
        captureStack($this, $this.u5l_1);
        $this.t5l_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).o5k().toString() + '`\n        Response status `' + response.v5k().toString() + '`\n        Response header `ContentType: ' + response.z51().v2o('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).z51().v2o('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
        delete $this.message;
        return $this;
      }
      r() {
        return this.t5l_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'NoTransformationFoundException');
    NoTransformationFoundExceptionClass = $;
  }
  return NoTransformationFoundExceptionClass;
}
//region block: exports
export {
  HttpClientCall as HttpClientCall2j6myj8ctykar,
};
//endregion

//# sourceMappingURL=HttpClientCall.mjs.map
